import { AxiosPromise } from 'axios';
import { http } from 'services';

import * as Types from './types';
import { getCaptchaToken } from 'helpers/captcha';

export const List = async ({
  params,
  filter,
}: Types.IApi.Registry.Request): Promise<AxiosPromise<{ data: { registers: Types.IApi.Registry.Response[]; }; }>> => {
  const token = await getCaptchaToken()

  return http.request.get<{ data: { registers: Types.IApi.Registry.Response[] } }>(`/register/open_source`, {
    headers: {
      ...(token ? { 'X-Turnstile-Token': token } : null)
    },
    params: {
      ...filter,
      page: params.page - 1,
      size: params.limit
    }
  });
};

export const RegsterRefs = ({
  registerId
}: Types.IApi.RegistryRefs.Request): AxiosPromise<{ data: Types.IApi.RegistryRefs.Response }> => {
  return http.request.get<{ data: Types.IApi.RegistryRefs.Response }>(`/reference/register/${registerId}`);
};

export const Single = async ({ id }): Promise<AxiosPromise<{ data: Types.IApi.Registry.Response; }>> => {
  const token = await getCaptchaToken()

  return http.request.get<{ data: Types.IApi.Registry.Response }>(`/register/open_source/${id}`, {
    headers: {
      ...(token ? { 'X-Turnstile-Token': token } : null)
    }
  });
};
